import axios from "axios";
import { emit } from "process";
import { CarDto } from "../dto/car-dto";

// Change this to match your backend URL
const API_BASE_URL =
  process.env.REACT_APP_CENTRAL_API || "http://localhost:3000";

const centralApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const ApiService = {
  getCarSpecsWithSearchCriteria: async (sources: string) => {
    const response = await centralApi.get(`/car-spec?source=${sources}`);
    return response.data;
  },

  findCarsBySpecifications: async (specifications: any) => {
    const response = await centralApi.post(
      `/car-spec/search-cars-by-spec-range`,
      specifications
    );
    return response.data;
  },

  emitCarDetails: async (car: CarDto) => {
    try {
      await centralApi.post(`/parser/emit-car-details`, car);
    } catch (error) {
      console.error("Error emitting car details:", error);
    }
  },
};

export default ApiService;
